import React, { useState } from "react"
import PropTypes from "prop-types"
// Hooks
import useTable from "../../hooks/useTable"
// Components
import TableFooter from "../TableFooter/TableFooter"
// Styles
import { Container, Wrapper, Header, Row, Cell } from "./Table.styles"

const Table = ({ headers, data, pageSize }) => {
    const [page, setPage] = useState(1)
    const { slice, range } = useTable(data, page, pageSize)

    return (
        <Container>
            <Wrapper>
                <tbody>
                    <Row>
                        {headers.map((column, index) => (
                            <Header
                                key={index}
                                width={column.width}
                                align={column.align}
                            >
                                {column.name}
                            </Header>
                        ))}
                    </Row>
                    {slice.map((row, index) => (
                        <Row key={index}>
                            {row.map((cell, index) => (
                                <Cell
                                    key={index}
                                    align={headers[index].align}
                                >
                                    {cell}
                                </Cell>
                            ))}
                        </Row>
                    ))}
                </tbody>
            </Wrapper>
            {(range.length > 1) ? (
                <TableFooter pages={range} setPage={setPage} page={page} slice={slice} />
            ) : (
                null
            )} </Container>
    )
}

Table.propTypes = {
    headers: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        size: PropTypes.number,
        align: PropTypes.string
    })),
    data: PropTypes.arrayOf(PropTypes.array),
    pageSize: PropTypes.number
}

export default Table
